import Vue from 'vue';

export default class ApiClient {
  constructor($http, baseUrl, baseUrlV2) {
    this.baseUrl = baseUrl;
    this.baseUrlV2 = baseUrlV2 || baseUrl;
    this.http = $http;
  }

  _get(url, params) {
    return this.#requestWithParams('get', url, params);
  }

  _getUnauthenticated(url, params) {
    return this.#requestWithParams('get', url, params, false);
  }

  _post(url, data) {
    return this.#request('post', url, data);
  }

  _postUnauthenticated(url, data) {
    return this.#request('post', url, data, false);
  }

  _put(url, data) {
    return this.#request('put', url, data);
  }

  _patch(url, data) {
    return this.#request('patch', url, data);
  }

  _delete(url, params) {
    return this.#requestWithParams('delete', url, params);
  }

  async #requestWithParams(action, url, params, includeAuthzHeader = true) {
    const accessToken = Vue.prototype.$globals.keycloak.token;
    const impersonateId = Vue.prototype.$localStorage.get('impersonateId');

    const headers = {
      Authorization: includeAuthzHeader ? `Bearer ${accessToken}` : undefined,
      'Content-Type': 'application/json',
      'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    if (impersonateId) {
      headers['X-Impersonate-Id'] = impersonateId;
    }

    const baseUrl = url.indexOf('v2/') === 0 ? this.baseUrlV2 : this.baseUrl;
    try{
      const response = await this.http[action](`${baseUrl}/${url}`, {
        headers,
        params: params || {}
      });
      return this.#handleResponse(response);
    } catch(response) {
      if(response.status === 401)
        Vue.prototype.$globals.keycloak.login();
      else
        throw response;
    }
  }

  async #request(action, url, data, includeAuthzHeader = true) {
    const accessToken = Vue.prototype.$globals.keycloak.token || '';

    const headers = {
      Authorization: includeAuthzHeader ? `Bearer ${accessToken}` : undefined,
      'Content-Type': 'application/json',
      'Time-Zone': Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    const baseUrl = url.indexOf('v2/') === 0 ? this.baseUrlV2 : this.baseUrl;
    try{
      const response = await this.http[action](`${baseUrl}/${url}`, data, {
        headers
      });
      return this.#handleResponse(response);
    } catch (response) {
      if(response.status === 401)
        Vue.prototype.$globals.keycloak.login();
      else
        throw response;
    }
  }

  #handleResponse(results) {
    if (!results || !results.ok) {
      return {};
    }

    const pageCount = results.headers.get('Pagination-Count') || 0;
    const responseFormat = results.headers.get('Content-Type') || '';

    if (pageCount && responseFormat === 'application/json') {
      return {
        count: parseInt(pageCount, 10),
        next: '',
        previous: '',
        results: results.body || []
      };
    }

    return results.body;
  }
}
